import React from 'react';

interface HistoricalBannerProps {
  date: string;
  onBackToToday: () => void;
}

export const HistoricalBanner: React.FC<HistoricalBannerProps> = ({ date, onBackToToday }) => {
  return (
    <div className="flex items-center justify-between bg-amber-50 border-b border-amber-200 px-6 py-2.5 text-sm">
      <span className="text-amber-800">
        You are viewing the report for {date}
      </span>
      <button
        onClick={onBackToToday}
        className="text-sm font-medium text-blue-600 hover:text-blue-700"
      >
        Back to today
      </button>
    </div>
  );
};
